export { Contacts } from '@/components/pages/contacts/Contacts';
